import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

import logger from './logger'
import { getVars } from './common'
import _set from 'lodash/set'

class Http {
  static instance: AxiosInstance

  static getInstance() {
    if (!Http.instance) {
      const { apiTimeout, apiUrl } = getVars()
      Http.instance = axios.create({
        baseURL: apiUrl,
        timeout: Number(apiTimeout),
      })
      logger.info('New Http Created!')
    }

    return Http.instance
  }
}

export function setUnauthenticatedCallback(onError: (err: AxiosError) => Promise<AxiosError | AxiosResponse>): number {
  function onFulfilled(res: AxiosResponse): AxiosResponse {
    return res
  }

  return Http.getInstance().interceptors.response.use(onFulfilled, onError)
}

export function setAuthenticationHeaderCallback(
  onFulfilled: (config: AxiosRequestConfig) => AxiosRequestConfig = (config: AxiosRequestConfig) => config
): number {
  return Http.getInstance().interceptors.request.use(onFulfilled)
}

export function addResponseInterceptor(
  onFulfilled: (res: AxiosResponse) => AxiosResponse = (res: AxiosResponse): AxiosResponse => res,
  onRejected: (err: AxiosError) => Promise<AxiosError> = (err: AxiosError): Promise<AxiosError> => Promise.resolve(err)
): number {
  return Http.getInstance().interceptors.response.use(onFulfilled, onRejected)
}

export function addRequestInterceptor(
  onFulfilled: (config: AxiosRequestConfig) => AxiosRequestConfig = (config: AxiosRequestConfig) => config,
  onRejected: (err: AxiosError) => Promise<AxiosError> = (err: AxiosError): Promise<AxiosError> => Promise.resolve(err)
): number {
  return Http.getInstance().interceptors.request.use(onFulfilled, onRejected)
}

export function ejectResponseInterceptor(id: number): void {
  return Http.getInstance().interceptors.response.eject(id)
}

export function ejectRequestInterceptor(id: number): void {
  return Http.getInstance().interceptors.request.eject(id)
}

export function setBaseUrl(baseURL: string): void {
  if (baseURL) _set(Http.getInstance().defaults, 'baseURL', baseURL)
}

export function setHeader(header: string, val: string): void {
  if (header && val) _set(Http.getInstance().defaults, `headers.${header}`, val)
}

export default Http.getInstance()
